import React from 'react';

import checkoutFamilyIcon from 'ck-core-client/graphics/checkout/checkout-family-icon.svg';

import { lang } from './lang';
import { CheckboxBanner } from '../CheckboxBanner';
import { PALETTE } from 'ck-core-client/source/data/Palette';
import { MonetaryValue } from 'ck-core/source/classes/MonetaryValue';

export const FamilyCheckboxBanner: React.SFC<{
	checked: boolean;
	handleChange: (checked: boolean) => void;
	familyUpgradePrice: MonetaryValue;
}> = ({ checked, handleChange, familyUpgradePrice }) => (
	<CheckboxBanner
		title={lang.TITLE}
		background={PALETTE.blue}
		className="CheckboxBanner--family"
		description={lang.DESCRIPTION(familyUpgradePrice.format())}
		iconUrl={checkoutFamilyIcon}
		checked={checked}
		handleChange={handleChange}
	/>
);
